import instantsearch from 'instantsearch.js/dist/instantsearch.js';
import * as searcher from './searchWidgets'

const resultLimit = 3;
const defaultIndex = 'AllPopular';
let searchStarted = false;
let userInput = '#dropSearchInput';
let maoriResourceSearch;
let knowledgeSearch;
let communitySearch;
let eventSearch;
const today = Math.floor((new Date().setHours(0,0,0,0))/1000);
let filter = "EndDate >= " + today + " OR Date >= " + today;
let maoriResourceFilter = "(Class:Project OR Class:Resource OR Class:Video OR Class:AlnProject OR Class:Audio OR Class:Flipbook OR Class:ExternalResource)";

generateMaoriResourceTopicFilter();

// We're on a search page, fire up Algolia ASAP
if ($('.js-search-page').length > 0) {
    startSearch();
} else {
    // Wait for user interaction
    $('#header__lead--search').click(function() {
        startSearch();
    });
}

function startSearch() {
    if (!searchStarted) {
        searchStarted = true;
        createSearch();
        initListeners();
    }
}

/**
 * Append the maori resource topics to the maori resource filter for use in createSearch()
 */
function generateMaoriResourceTopicFilter() {
    if ($(userInput).data('maoriResourceTopics')) {
        maoriResourceFilter += " AND (";
        let types = $(userInput).data('maoriResourceTopics').split(',');
        for (let i = 0; i < types.length; i++) {
            maoriResourceFilter += "MaoriResourceTopic:'" + types[i] + "'";
            if (i != types.length -1 ) {
                maoriResourceFilter += ' OR '
            }
        }
        maoriResourceFilter += ")";
    }
}

/**
 * Create and start a filtered InstantSearch search
 */
function createSearch() {
    maoriResourceSearch = searcher.getSearch(defaultIndex, resultLimit, false, maoriResourceFilter);
    knowledgeSearch = searcher.getSearch(defaultIndex, resultLimit, false,
        'Class:Project OR Class:Resource OR Class:Video OR Class:AlnProject OR Class:Audio');
    communitySearch = searcher.getSearch(defaultIndex, resultLimit, false,
        'Class:Article OR Class:Award OR Class:CommunityGroupHolder OR Class:CommunityPerson OR Class:SpecialisedLandingHolder');
    eventSearch = searcher.getSearch(defaultIndex, resultLimit, false, 'Class:Event OR Class:Workshop OR Class:KonoPLD', filter);

    maoriResourceSearch.addWidget(searcher.widgetInput(userInput));
    knowledgeSearch.addWidget(searcher.widgetInput(userInput));
    communitySearch.addWidget(searcher.widgetInput(userInput));
    eventSearch.addWidget(searcher.widgetInput(userInput));

    maoriResourceSearch.addWidget(searcher.widgetDropHits('#hitsMaoriResource'));
    knowledgeSearch.addWidget(searcher.widgetDropHits('#hitsKnowledge'));
    communitySearch.addWidget(searcher.widgetDropHits('#hitsCommunity'));
    eventSearch.addWidget(searcher.widgetDropHits('#hitsEvent'));

    maoriResourceSearch.start();
    knowledgeSearch.start();
    communitySearch.start();
    eventSearch.start();
}


/**
 * Sets up listeners for various sections of the search page to
 * give a more interactive and useful search experience.
 */
function initListeners() {
    $('#allMaoriResources').click(function() {
        $('#allMaoriResources').prop('href',
        'KnowledgeCentreSearch?term=' + $(userInput).val());

        if ($(userInput).data('maoriResourceTopics')) {
            let types = $(userInput).data('maoriResourceTopics').split(',');
            let typeFilter = '';
            for (let i = 0; i<types.length; i++) {
                typeFilter += '&dFR%5BMaoriResourceTopic%5D%5B' + i + '%5D=' + types[i];
            }
            $('#allMaoriResources').prop('href', $('#allMaoriResources').attr('href') + typeFilter);
        }
    });

    $('#allKnowledge').click(function() {
        $('#allKnowledge').prop('href',
        'KnowledgeCentreSearch?term=' + $(userInput).val());
    });

    $('#allCommunity').click(function() {
        $('#allCommunity').prop('href', 'Search?term=' + $(userInput).val());

        if ($(userInput).data('communityTypes')) {
            let types = $(userInput).data('communityTypes').split(',');
            let typeFilter = '';
            for (let i = 0; i<types.length; i++) {
                typeFilter += '&dFR%5BType%5D%5B' + i + '%5D=' + types[i];
            }
            $('#allCommunity').prop('href', $('#allCommunity').attr('href') + typeFilter);
        }
    });

    $('#allEvents').click(function() {
        $('#allEvents').prop('href', 'Search?term=' + $(userInput).val());

        if ($(userInput).data('eventTypes')) {
            let types = $(userInput).data('eventTypes').split(',');
            let typeFilter = '';
            for (let i = 0; i<types.length; i++) {
                typeFilter += '&dFR%5BType%5D%5B' + i + '%5D=' + types[i];
            }
            $('#allEvents').prop('href', $('#allEvents').attr('href') + typeFilter);
        }
    });

    $('#searchInput').on('submit', (e) => {
        window.location.href =
            '../Search?term=' + $(userInput).val();
        e.preventDefault();
    });
}



// WEBPACK FOOTER //
// ./src/js/search/dropSearch.js